import { render } from "./ui-popovers.vue?vue&type=template&id=3de5b4b2"
import script from "./ui-popovers.vue?vue&type=script&lang=js"
export * from "./ui-popovers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__